import * as services from 'services/unsubscribe';
export const SET_ERROR = 'projects/SET_ERROR';
export const CLEAR_ERROR = 'projects/CLEAR_ERROR';
export const REQUEST_STARTED = 'projects/REQUEST_STARTED';
export const REQUEST_COMPLETED = 'projects/REQUEST_SUCCESSFUL';
export const SET_UNSUBSCRIBED_DOMAINS = 'domains/SET_UNSUBSCRIBED_DOMAINS';
export const SET_UNSUBSCRIBED_EMAILS = 'domains/SET_UNSUBSCRIBED_EMAILS';

export const setError = error => ({
  type: SET_ERROR,
  error,
});

export const clearError = () => ({
  type: CLEAR_ERROR,
});

export const requestStarted = () => dispatch => {
  dispatch(clearError());
  dispatch({ type: REQUEST_STARTED });
};
export const requestCompleted = () => ({
  type: REQUEST_COMPLETED,
});

export const setUnsubscribedDomains = domains => ({
  type: SET_UNSUBSCRIBED_DOMAINS,
  domains,
});

export const setUnsubscribedEmails = emails => ({
  type: SET_UNSUBSCRIBED_EMAILS,
  emails,
});

export const fetchUnsubscribedDomains = () => dispatch => {
  dispatch(requestStarted());
  services
    .getUnsubscribedDomains()
    .then(domains => {
      dispatch(setUnsubscribedDomains(domains));
      dispatch(requestCompleted());
    })
    .catch(() => {
      dispatch(setError('Error fetching domains'));
      dispatch(requestCompleted());
    });
};

export const fetchUnsubscribeEmails = email => dispatch => {
  dispatch(requestStarted());
  services
    .getUnsubscribedEmails(email)
    .then(emails => {
      dispatch(setUnsubscribedEmails(emails.unsubsribers));
      dispatch(requestCompleted());
    })
    .catch(() => {
      dispatch(setError('Error fetching emails'));
      dispatch(requestCompleted());
    });
};
